import { type Enum } from '@webapp/infrastructure/types/Enum'

export const PermissionCategoryTypes = {
  GENERAL: 'general',
  SETTINGS: 'settings',
} as const
export type PermissionCategoryTypeEnum = Enum<typeof PermissionCategoryTypes>
